import { render, staticRenderFns } from "./NflSavedLineup.vue?vue&type=template&id=24e50514&scoped=true"
import script from "./NflSavedLineup.vue?vue&type=script&lang=js"
export * from "./NflSavedLineup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e50514",
  null
  
)

export default component.exports